import { Link } from "react-router-dom";
import { Ticket } from "lucide-react";
import { NAV_LINKS } from "@/lib/data";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#2C3E50] text-slate-300 mt-0">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2 font-heading font-extrabold text-xl text-white">
            <span className="grid place-items-center w-9 h-9 rounded-xl bg-[#FF6B35] text-white">
              <Ticket size={18} />
            </span>
            Tixter<span className="text-[#FF6B35]">.nl</span>
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
            Vergelijk &amp; bespaar op tickets voor concerten, festivals, vliegtickets en
            attracties. Wij verwijzen je door naar betrouwbare, officiele aanbieders.
          </p>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Categorieen</h4>
          <ul className="space-y-2 text-sm">
            {NAV_LINKS.filter((l) => l.to !== "/").map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-[#FF6B35] transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Info</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/blog" className="hover:text-[#FF6B35] transition-colors">Blog</Link></li>
            <li><span className="text-slate-400">info@tixter.nl</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs text-slate-400 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Tixter.nl – Alle rechten voorbehouden.</span>
          <span>Tixter.nl is een onafhankelijke vergelijkingsdienst en werkt met affiliate links.</span>
        </div>
      </div>
    </footer>
  );
}
